import React from "react";
import ReactDOM from "react-dom";

import "./index.css";

import Alert from "./components/Alert";

import Volunteering from "./Volunteering";
import Tickets from "./Tickets";

/* uncomment for testing locally
window.notifySettings = {
	id: "tickets", // volunteering, tickets
};*/

const target = document.getElementById("notify-root");
if (target) {
	if (window.notifySettings) {
		const { id } = window.notifySettings;

		if (id === "volunteering") {
			ReactDOM.render(
				<React.StrictMode>
					<Volunteering />
				</React.StrictMode>,
				target,
			);
		} else if (id === "tickets") {
			ReactDOM.render(
				<React.StrictMode>
					<Tickets />
				</React.StrictMode>,
				target,
			);
		} else {
			ReactDOM.render(
				<React.StrictMode>
					<Alert data={{ type: "error", text: "No survey found." }} />
				</React.StrictMode>,
				target,
			);
		}
	} else {
		ReactDOM.render(
			<React.StrictMode>
				<Alert data={{ type: "error", text: "An error has occurred." }} />
			</React.StrictMode>,
			target,
		);
	}
}
